import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody,Modal,ModalHeader,Button,Label,Input} from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import 'jspdf-autotable';

export default function Certficates() {
      const [agent, setAgent] = useState('')
      const [agentCode, setAgentcode] = useState('')
      const [certificates, setCertificates] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 20;
    const totalPages = Math.ceil(certificates.length / rowsPerPage);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentPolicies = certificates.slice(indexOfFirstRow, indexOfLastRow)
    const [search, setSearch] = useState('')
      const [credentials, setCredentials] = useState(null)
      const [isAuth, setIsauth] = useState(false)
      const company = 'Definite'
    
      useEffect(()=>{
      const getCredentials =async()=>{
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
        const data = await res.json();
        const {Username, Password} = data;
        const cred = btoa(`${Username}:${Password}`)
        setCredentials(btoa(`${Username}:${Password}`))
        setIsauth(true)
    
    
      }
      getCredentials()
    
      },[])
    

        useEffect(() => {
      
        const user = localStorage.getItem('definiteagent'); // Retrieve email
        if (user) {
            
            setAgent(user)
        } else {
        
        }
        }, []);
      
        useEffect(()=>{
            const getAgentcode =async()=>{
                const res =await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${agent}`,{
                    method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                });
                const data = await res.json();
                setAgentcode(data.OID)   
      
            }
            if(agent && isAuth){
                getAgentcode()
            }
        },[agent,isAuth])


        useEffect(()=>{
            const getCertificates =async()=>{
                const res = await fetch(`https://digitalapi.definiteassurance.com/api/getAllcertificates?code=${agentCode}`,{
                       method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                })
                const data = await res.json();
                setCertificates(data)
            }

            if(agentCode && isAuth){
                getCertificates();
            }

        },[agentCode, isAuth])


        useEffect(()=>{
            const getCertificates =async()=>{
                const res = await fetch(`https://digitalapi.definiteassurance.com/api/getSearchcertificates?code=${agentCode}&search=${search}`,{
                       method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
                })
                const data = await res.json();
                setCertificates(data)
            }

            if(search && isAuth){
                getCertificates();
            }

        },[search,isAuth])
function formateDateISO(input) {
    // Handle null or undefined input
    if (input === null || input === undefined || input === '') {
        return null; // or return an empty string "" depending on your needs
    }
    
    // Handle string input
    if (typeof input === 'string') {
        if (!input) return null; // handle empty string
        return input.split('T')[0];
    }
    
    // Handle Date object
    if (input instanceof Date) {
        // Check if the date is valid
        if (isNaN(input.getTime())) {
            throw new Error('Invalid Date object');
        }
        return input.toISOString().split('T')[0];
    }
    
    throw new Error('Invalid input: Expected ISO String, Date Object, or null');
}
  return (
    <div className="page-content">

         <Breadcrumbs title="Definite Assurance" breadcrumbItem={`Certificates`} />
            <Card className="mini-stats-wid">
                <CardBody>
                      <div className="searchInput">
                         <FloatingLabel className='formInput2' controlId="floatingInputGrid" label="Search registration" onChange={(e)=>{setSearch(e.target.value)}}>
                            <Form.Control  className='inputSearch' value={search}  type="text" placeholder="Search" />
                        </FloatingLabel>
                    </div>
                                    <div className="table-responsive" style={{padding:'10px'}}>
                    
                    
                                    <Table striped bordered hover id="policy-table">
                                    <thead>
                                        <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Registration</th>
                                        <th scope="col">Valid From</th>     
                                        <th scope="col">Expiry Date</th>
                                        <th scope="col">Certificate</th>
                                        
                    
                    
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentPolicies.map((val, index) => {
                                        // Calculate the correct index based on current page
                                        const globalIndex = indexOfFirstRow + index;
                                        const transactionDate = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.DateDone)
                                        const valid = `${val.ValidFrom}`
                                        const Expiry = `${val.ExpiryDate}`
                                            if(certificates.length !== 0){
                                                    return (
                                                    <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{val.Narration}</td>
                                                   <td>{formateDateISO(valid)}</td>
                                                  

                                                    <td>{formateDateISO(Expiry)}</td>
                                                    <td><a href={val.CertificatePdf} rel="noreferrer" target="_blank" >Download certificate</a></td>
                                                    </tr>
                                                );

                                            }        

                    
                                        })}
                                    </tbody>
                                    </Table>
                    
                                    {/* Pagination controls */}
                                    <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, certificates.length)} of {certificates.length} entries
                                    </div>
                                    <div>
                                        <button 
                                        className="btn btn-sm btn-outline-primary mx-1"
                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                        disabled={currentPage === 1}
                                        >
                                        Previous
                                        </button>
                                        
                                        {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                                        <button
                                            key={page}
                                            className={`btn btn-sm mx-1 ${currentPage === page ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => setCurrentPage(page)}
                                        >
                                            {page}
                                        </button>
                                        ))}
                                        
                                        <button 
                                        className="btn btn-sm btn-outline-primary mx-1"
                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                        disabled={currentPage === totalPages}
                                        >
                                        Next
                                        </button>
                                    </div>
                                    </div>
                                    </div>

                </CardBody>
            </Card>
    </div>
  )
}
